// extracted by mini-css-extract-plugin
module.exports = {"formInputNumber":"Number_formInputNumber__pb2oo"};